var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c("div", { staticClass: "header clearfix" }, [
        _c(
          "div",
          { staticClass: "container" },
          [
            _c(
              "el-form",
              { attrs: { inline: "" } },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "商品搜索：" } },
                  [
                    _c(
                      "el-input",
                      {
                        staticClass: "selWidth",
                        attrs: {
                          placeholder: "请输入商品名称，关键字，产品编号",
                        },
                        on: {
                          input: function ($event) {
                            return _vm.onInput($event)
                          },
                        },
                        model: {
                          value: _vm.tableFrom.keywords,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.tableFrom,
                              "keywords",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "tableFrom.keywords",
                        },
                      },
                      [
                        _c("el-button", {
                          attrs: { slot: "append", icon: "el-icon-search" },
                          on: {
                            click: function ($event) {
                              return _vm.getList(1)
                            },
                          },
                          slot: "append",
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          ref: "table",
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData.data,
            size: "mini",
            "tooltip-effect": "dark",
            "highlight-current-row": "",
            "max-height": "400",
          },
          on: { "selection-change": _vm.handleSelectionChange },
        },
        [
          _vm.handleNum === "many"
            ? _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              })
            : _vm._e(),
          _vm.handleNum !== "many"
            ? _c("el-table-column", {
                key: "1",
                attrs: { width: "55" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("el-radio", {
                            attrs: { label: scope.row.id },
                            nativeOn: {
                              change: function ($event) {
                                return _vm.getTemplateRow(scope.row)
                              },
                            },
                            model: {
                              value: _vm.templateRadio,
                              callback: function ($$v) {
                                _vm.templateRadio = $$v
                              },
                              expression: "templateRadio",
                            },
                          }),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  1700966514
                ),
              })
            : _vm._e(),
          _c("el-table-column", {
            attrs: { prop: "id", label: "ID", "min-width": "50" },
          }),
          _c("el-table-column", {
            attrs: { label: "商品图", "min-width": "80" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      { staticClass: "demo-image__preview line-heightOne" },
                      [
                        _c("el-image", {
                          attrs: {
                            src: scope.row.image,
                            "preview-src-list": [scope.row.image],
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "storeName", label: "商品名称", "min-width": "180" },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "block mb20" },
        [
          _c("el-pagination", {
            attrs: {
              "page-sizes": [1, 2, 3, 4],
              "page-size": _vm.tableFrom.limit,
              "current-page": _vm.tableFrom.page,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.tableData.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.pageChange,
            },
          }),
        ],
        1
      ),
      _vm.handleNum === "many"
        ? _c(
            "div",
            { staticClass: "right-align" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.ok },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }